import { openModal } from '../../../../store/actions/modal/modal';
import { openDialogRemoveItems } from '../../../../store/actions/modal/removeItems';
import { approveItemCategoryRecommendation } from '../../../../store/actions/nodeMenu/approve';
import { nodeMenuCopy } from '../../../../store/actions/nodeMenu/copy';
import { nodeMenuCut } from '../../../../store/actions/nodeMenu/cut';
import { markForCategorization } from '../../../../store/actions/nodeMenu/markForCategorization';
import { rejectItemCategoryRecommendation } from '../../../../store/actions/nodeMenu/reject';
import {
  CATALOG_TYPE_ITEMS_CATEGORY_RECOMMENDATIONS,
  CATALOG_TYPE_THEMES,
} from '../../../../utils/types/catalogTypes';

export function getMultiselectActions(_, { dispatch, nodeItem, tree, paneData }) {
  const { isInSuggestion, isItems, isUncategorized, isItemCategoryRecommendation } =
    nodeItem.node;
  const nodeActions = {};
  const targetPaneCatalogType = paneData?.targetPaneCatalog.catalogType;
  const sourcePaneCatalogType = paneData?.sourcePaneCatalog.catalogType;
  if (isInSuggestion) {
    nodeActions.openAlterSuggestionsDialog = () =>
      dispatch(openModal('AlterSuggestionsDialog', { tree, nodeItem }));
  } else if (isUncategorized) {
    nodeActions.nodeMenuCut = () => dispatch(markForCategorization(tree, nodeItem));
  } else if (isItemCategoryRecommendation) {
    nodeActions.nodeMenuReject = () =>
      dispatch(rejectItemCategoryRecommendation(tree, nodeItem));
    nodeActions.nodeMenuApprove = () =>
      dispatch(approveItemCategoryRecommendation(tree, nodeItem));
    if (
      targetPaneCatalogType === CATALOG_TYPE_THEMES &&
      sourcePaneCatalogType === CATALOG_TYPE_ITEMS_CATEGORY_RECOMMENDATIONS
    )
      nodeActions.openAlterSuggestionsDialog = () =>
        dispatch(openModal('AlterSuggestionsDialog', { tree, nodeItem }));
  } else {
    nodeActions.nodeMenuCopy = () => dispatch(nodeMenuCopy(tree, nodeItem));
    nodeActions.nodeMenuCut = () => dispatch(nodeMenuCut(tree, nodeItem));
    if (isItems) {
      nodeActions.openDialogRemoveItem = () =>
        dispatch(openDialogRemoveItems(tree, nodeItem));
    }
  }
  return nodeActions;
}
